import React from "react";
import { getUrl } from "../../helpers/Pipes";
import { Icon } from "../Icon/Icon";

export const Logo = () => {
  return (
    <h1 className="logo">
      <a target="_blank" href={getUrl("home")}>
        <Icon setViewBox="yes" name="logo" />
        <span className="logo-text">Compass</span>
      </a>
    </h1>
  );
};
